export const mapStyle = {
  zIndex: -1,
  overflow: 'hidden',
};
